import Footer from "../../components/Footer/Footer";
import { galleryImg } from "./GalleryFiles";

function Gallery() {
  return (
    <>
      <section className="bg-black text-white min-h-screen">
        <div className="login-banner relative justify-center flex bg-brand-yellow">
          <h1 className="text-white absolute bottom-[20px] sm:bottom-[25px] text-[26px] sm:text-[34px] md:text-[40px] font-extrabold uppercase text-center px-4">
            Workplace Gallery
          </h1>
        </div>

        {/* Gallery Grid */}
        <div className="container page-padding py-12 sm:py-16 md:py-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {galleryImg.map((image) => (
              <div
                key={image.id}
                className="overflow-hidden rounded-2xl border border-neutral-900 hover:border-brand-yellow transition duration-300 group shadow-lg"
              >
                <img
                  alt="gym_gallery_photo"
                  className="w-full h-64 sm:h-72 lg:h-80 object-cover group-hover:scale-105 transition duration-500"
                  src={image.img}
                />
              </div>
            ))}
          </div>
        </div>

        <Footer />
      </section>
    </>
  );
}

export default Gallery;
